// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/play.js';

import { paths } from '../generated/play';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('play', Original, paths);
